import {api} from './api';

export const assessmentApi = {
  getAssessmentsForMeeting: async (meetingId) => {
    const {assessments} = await api.assessmentSvcRequest('GET', `/assessments/${meetingId}`);
    return assessments;
  },

  getAssessmentForMeetingAndUser: async (meetingId, userId) => {
    const {assessment} = await api.assessmentSvcRequest('GET', `/assessments/${meetingId}/${userId}`);
    return assessment;
  }
};